import {Point} from '@app/modules/svg/model/Point';
import {Ellipse} from '@app/modules/svg/model/Ellipse';

export class Polygon {
  public static getEllipticPoints(ellipse: Ellipse, count: number): Point[] {
    const stepAngle: number = 2 * Math.PI / count;
    /* for odd number of vertices add 90 degree shift angle */
    const shiftAngle: number = count % 2 === 0 ? 0 : Math.PI / 2;

    const points: Point[] = [];
    for (let i = 0; i < count; i++) {
      const ang = shiftAngle + (stepAngle * i);

      const x: number = ellipse.cx + ellipse.rx * Math.cos(ang);
      const y: number = ellipse.cy + ellipse.ry * Math.sin(ang);
      points.push({x, y});
    }
    return points;
  }
}
